import { render } from "./CategoryPNG.vue?vue&type=template&id=40c9b302&scoped=true"
import script from "./CategoryPNG.vue?vue&type=script&lang=js"
export * from "./CategoryPNG.vue?vue&type=script&lang=js"

import "./CategoryPNG.vue?vue&type=style&index=0&id=40c9b302&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c9b302"]])

export default __exports__